import { DEV_APP_VERSION } from '@globals/appVersion'

/**
 * A build that could not resolve a release id carries the dev placeholder, which
 * never equals a real one — so comparing it would report a deploy on every poll
 * and turn every route change into a full page load.
 */
const isUsableVersion = (version: string) => !!version && version !== DEV_APP_VERSION

/**
 * A newer release is deployed when the origin names a version other than the one
 * compiled into this bundle. Both are the `APP_VERSION` the build resolved, so
 * they only differ once a newer build is serving.
 */
export const hasNewAppVersion = (appVersion: string, deployedVersion?: string): boolean =>
  isUsableVersion(appVersion) &&
  !!deployedVersion &&
  isUsableVersion(deployedVersion) &&
  deployedVersion !== appVersion

/**
 * The etag of `/` is not a release id, so there is nothing in the bundle to
 * compare it against — the first etag this session saw is the baseline, and a
 * later one that differs is treated as a deploy.
 */
export const hasNewEtag = (initialEtag?: string, currentEtag?: string): boolean =>
  !!initialEtag && !!currentEtag && initialEtag !== currentEtag
